import React from "react";
import PropTypes from "prop-types";

const ErrorRender = ({ errors }) => {
  return (
    <div
      className="alert alert-danger mt-2"
      style={{ paddingBottom: 10 }}
    >
      <strong>{errors}</strong>
    </div>
  );
};

ErrorRender.propTypes = {
  errors: PropTypes.string
};

export default ErrorRender;
